import useAppStore from "@/context/store";
import { sendSms, SEND_SMS_REASON } from "@/services";
import { useSecondDown } from "@/utils/hooks/useSecondDown";
import { useMemoizedFn } from "ahooks";
import { Button } from "antd";
import { useRef, type ReactEventHandler } from "react";
import HBInput from "../HBInput";
import HBMessage from "../HBMessage";
import HBModal, { HBModalProps } from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import VerifyInput from "../Verify/VerifyInput";
import styles from "./index.module.less";

const VerifyDialog = ModalWrap(function (
  props: HBModalProps & { slideVerifyRef?: any }
) {
  return (
    <HBModal
      {...props}
      footer={null}
      className={styles.verify}
      title={null}
      width={400}
      bodyStyle={{
        padding: "39px 50px 48px",
      }}
    >
      <div className={styles.title}>绑定手机号</div>
      <div className={styles.desc}>
        听说机器人不会拖动滑块，试试看你行不行？
      </div>
      <VerifyInput
        id="captcha_send_validate"
        ref={props.slideVerifyRef}
        type="register"
        onOk={props.onOk}
      />
    </HBModal>
  );
});

interface IProps {
  tel?: string | (() => string);
  validate?: any;
  value?: string;
  onChange?: ReactEventHandler<HTMLInputElement>;
}

export function CaptchaInput({ tel, validate, value, onChange }: IProps = {}) {
  const { count: sendSmsCountDown, reset: resetCountDown } = useSecondDown({
    second: 60,
  });

  const user = useAppStore((s) => s.user);

  const verifiedDataRef = useRef(validate);

  const getTel = useMemoizedFn(() => {
    if (typeof tel === "string") {
      return tel;
    }

    if (typeof tel === "function") {
      return tel();
    }

    return "";
  });

  const sendSmsClick = async (needValidate = false) => {
    if (!getTel()) {
      HBMessage.error("请先输入手机号");
      return;
    }

    // 已登录时，仅第一次需要人机验证
    if (!verifiedDataRef.current) {
      // 弹验证弹窗
      VerifyDialog.open({
        title: "最后一步啦！人机校验",
        onOk: async (data) => {
          verifiedDataRef.current = data;
          // 重新触发
          sendSmsClick(true);
        },
      });

      return;
    }

    const result = await sendSms({
      reason: SEND_SMS_REASON.bindHuaban,
      tel: getTel(),
      ...(needValidate ? { validate: verifiedDataRef.current } : null),
    });

    if (!user) {
      // 未登录场景下，需要清空验证信息，使下次发送继续触发人机验证
      verifiedDataRef.current = null;
    }

    if (!result.err) {
      resetCountDown();
    }
  };

  return (
    <HBInput
      placeholder="验证码"
      value={value}
      onChange={onChange}
      addonAfter={
        <Button
          type="primary"
          disabled={sendSmsCountDown > 0}
          onClick={() => sendSmsClick()}
          data-gd-click="button_click"
          data-button-name="获取验证码"
        >
          {verifiedDataRef.current ? "重新发送" : "获取验证码"}
          {sendSmsCountDown ? sendSmsCountDown + "s" : ""}
        </Button>
      }
    />
  );
}
